export default __webpack_public_path__ + "static/one-stop-shop-ux-agency-4883c383838a05b42a9aa5d0ba7d0b4e.pdf";